'use client';

import { CircularProgress } from '@mui/material';
import { sendCheckoutPageViewEvent } from '@nrdy-marketing-engine/tracking/src/experiment/checkout-experiment';
import { useEffect } from 'react';
import { CartStep } from '../@types/cart-step';
import { useCartContext } from './cart-context';
import AccountStep from './components/account-step/account-step';
import CartMissing from './components/cart-missing/cart-missing';
import DetailsStep from './components/details-step/details-step';

/**
 * Renders the main cart component.
 **/
export default function Cart() {
  const { cartStep } = useCartContext();

  useEffect(() => {
    sendCheckoutPageViewEvent();
  }, []);

  switch (cartStep) {
    case CartStep.Loading:
      return <CircularProgress sx={{ alignSelf: 'center' }} />;
    case CartStep.Account:
      return <AccountStep />;
    case CartStep.Details:
      return <DetailsStep />;
    default:
      return <CartMissing />;
  }
}
